import { isEmpty, isNumber } from 'lodash-es'

/**
 * Returns an object with non-empty attribute values
 * @param {Object} targetObject Any object
 */
export default function(targetObject) {
  const cleanObject = {}

  Object.keys(targetObject).forEach((key) => {
    const current = targetObject[key]
    if (!isEmpty(current) || isNumber(current)) {
      cleanObject[key] = current
    }
  })

  return cleanObject
}
